<script setup lang="ts">
const solutions = [
  'Solusi percepatan pencairan dana COD saat paketmu masih dalam perjalanan.',
  'Arus kas semakin lancar untuk mendukung operasional dan pengembangan bisnismu.'
]
</script>

<template>
  <div class="flex flex-col gap-11 py-4 lg:py-16">
    <UiSectionWrapper
      image-class="lg:order-first"
      title="Dana COD Cair Lebih Cepat dengan COD Advance"
      description="Cairkan hingga 50% dana COD lebih awal saat paket diambil oleh kurir, tanpa perlu menunggu paket sampai tujuan."
      hero-image="/images/batch-2/cod-hero-coda.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
          <div
            v-for="(solution, index) in solutions"
            :key="index"
            class="flex gap-2"
          >
            <Icon
              class="text-primary flex-none"
              name="material-symbols:verified"
              size="24px"
            />
            <p class="text-sm lg:text-lg flex-1">
              {{ solution }}
            </p>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
  </div>
</template>
